import * as styles from "./SearchFilter.css";

import { useAtom } from "jotai";

import { Icon } from "@frontend/components/atoms/Icon";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "@frontend/components/atoms/Select";
import { useLingui } from "@lingui/react";

import { SearchFieldFilterLabel, SearchFieldLabels } from "../../i18n";
import { SEARCH_FIELDS, type SearchField, searchFieldAtom } from "../../stores";

export function SearchFilter() {
  const { _ } = useLingui();

  const [field, setField] = useAtom(searchFieldAtom);

  const items = SEARCH_FIELDS.map((value) => ({
    value,
    label: _(SearchFieldLabels[value]),
  }));

  const handleValueChange = (value: string | null) => {
    if (value) {
      setField(value as SearchField);
    }
  };

  return (
    <Select items={items} value={field} onValueChange={handleValueChange}>
      <SelectTrigger
        variant="ghost"
        hideIcon
        className={styles.trigger}
        aria-label={_(SearchFieldFilterLabel)}
        title={_(SearchFieldLabels[field])}
      >
        <Icon
          name="ListFilter"
          size="sm"
          className={styles.icon({ active: field !== "all" })}
        />
      </SelectTrigger>

      <SelectContent
        align="end"
        alignItemWithTrigger={false}
        style={{ width: "10rem" }}
      >
        {items.map((item) => (
          <SelectItem key={item.value} value={item.value}>
            {item.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
